import { I18nContext, I18nextProvider } from 'react-i18next';
import React, { useContext } from 'react';
import clsx from 'clsx';
import { createDefaultI18nextInstance } from './i18n.js';
import { themeClass } from './styles/theme.css.js';

const PageComponentsProvider = ({ children, className }) => {
    const i18nContext = useContext(I18nContext);
    const content = React.createElement("div", { className: clsx(themeClass, className) }, children);
    if (i18nContext) {
        return content;
    }
    return (React.createElement(I18nextProvider, { i18n: createDefaultI18nextInstance() }, content));
};

export { PageComponentsProvider };
//# sourceMappingURL=PageComponentsProvider.js.map
